import { CheckAvailableCreditCTA } from "./ctas";
export var BrandReferralUseCreditIA = function BrandReferralUseCreditIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize), BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return CheckAvailableCreditCTA(strictLocalize);
};
var BRAND_REFERRALS_USE_CREDIT_TITLE = function BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "zvQaIx",
    defaultMessage: [{
      "type": 0,
      "value": "Como usar o crédito dos convites de marcas"
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize) {
  return strictLocalize({
    id: "dkqwac",
    defaultMessage: [{
      "type": 0,
      "value": "Após receber o crédito, este é automaticamente aplicado à próxima encomenda em qualquer marca (não é preciso fazer nada). Se não usar a totalidade do crédito de uma vez, qualquer montante restante será acumulado. Para verificar o crédito disponível, aceda a \"Crédito disponível\" em \"Conta\"."
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize) {
  return strictLocalize({
    id: "DthCDL",
    defaultMessage: [{
      "type": 0,
      "value": "Se tiver curiosidade em saber quanto crédito recebeu com os convites a marcas que enviou, aceda a \"Convidar marcas\" em \"Conta\" e selecione o separador \"Marcas que aderiram\"."
    }]
  });
};